<template>
  <div class="size step">
    <div>
      <div class="step-scroll">
        <div class="step-content">
          <div class="landing">
            <div>
              <img
                src="https://assets.needlepaint.com/images/custom-needlepoint-belt.jpg"
              />
            </div>
            <div>
                <h2>Introducing the {{ this.productInfo.productName }} Builder!</h2>
                
                <p>
                    Create your very own one-of-a-kind custom needlepoint {{ this.productInfo.productName.toLowerCase() }}
                    with our new interactive {{ this.productInfo.productName }} Builder!
                </p>
                <p>Select the icons, dates, initials or memories that are important to you. Select a background color, {{ this.productInfo.productName.toLowerCase() }} leather color and add the icons to the {{ this.productInfo.productName.toLowerCase() }} in the order you select!  </p>
                <p>To get started choose a size below.</p>

            </div>
          </div>

          <!--<ProductSizes :product="productInfo" :userProduct="userProduct" />-->
          <ProductSizes :isOpen="true" :isPicker="false" v-on="$listeners" />

          <div>
              <p>When complete, you can purchase a needlepoint kit or a hand-stitched and finished {{ this.productInfo.productName.toLowerCase() }}.</p>
              <p>
                  Finished hand-stitched needlepoint leather {{ this.productInfo.productName.toLowerCase() }}s start at
                  ${{
                    (
                      Math.round(
                        this.productInfo.sizes.find(
                          (s) => s.sizeId == pricingSizeId
                        ).sizePrice))
                  }}
                  and needlepoint {{ this.productInfo.productName.toLowerCase() }} canvases start at
                  ${{
                    (
                      Math.round(
                        this.productInfo.sizes.find(
                          (s) => s.sizeId == pricingSizeId
                        ).sizeCanvasPrice) )
                  }}
                  .
              </p>
              <!--<p><router-link to="/motifs" class="button content-button">Design My {{ this.productInfo.productName }}</router-link></p>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductSizes from "@/components/ProductSizes.vue";

import Globals from "@/globals.js";
import { mapState } from "vuex";

export default {
  name: "Size",
  computed: {
      ...mapState(["productInfo", "userProduct"]),

      pricingSizeId: function () {
          let size = this.productInfo.sizes.reduce(function (prev, curr) {
              return prev.sizeWidth < curr.sizeWidth ? prev : curr;
          });
          return size.sizeId;
      },
  },
  components: {
    ProductSizes,
        },
        beforeCreate() {
            if (Globals.getProductType() == 7) {
                //this.$store.dispatch("setUserProductSize", this.$store.state.productInfo.sizes.find(({ sizeIsDefault }) => sizeIsDefault == true).sizeId);
                this.$router.push('motifs');
            }
            //console.log(Globals.getProductType());
        },
  mounted() {
    //console.log(this.$route.query.pd);
  },
};
</script>
<style>

    .landing {
        display: flex;
        -moz-column-gap: 2em;
        column-gap: 2em;
        text-align: left;
        margin: 2em 0 2em;
        flex-wrap: wrap;
        justify-content: center;
        row-gap: 1em;
    }

        .landing > div {
            flex: 1 1 auto;
        }

            .landing > div:first-child {
                width: 12em;
                /*! justify-content: center; */
                /*! display: flex; */
            }

            .landing > div:last-child {
                width: 70%;
            }

        .landing img {
            width: 100%;
            max-width: 300px;
            border: solid 1px #ccc;
            display: block;
            margin: auto;
        }

        .landing h2 {
            font-size: 1.35em;
            color: #288b7a;
            margin: 0 0 .5em;
        }

        .landing p {
            font-size: 1.1em;
            margin: 0 0 .5em;
            line-height: 1.5em;
        }

    .key-fob .size.step {
        display:none;
    }

</style>
